import { AlertIcon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { formatNumber, guardNumber } from "@msuite/utils/numbers";
import type { OrderFormSchema } from "@msuite/utils/schemas";
import type { ArticleListItem } from "@msuite/utils/types";
import { useFormContext, useWatch } from "react-hook-form";
import { useOrderFormContext } from "../context";

/** Props Interface */
interface OrderFormArticlesHintInputProps {
	item: ArticleListItem;
}

export function OrderFormArticlesHintInput({ item }: OrderFormArticlesHintInputProps) {
	/** Context */
	const { getItemIndex } = useOrderFormContext();
	const itemIndex = getItemIndex(item.id);

	/** Hooks */
	const { t } = useTranslation();
	const methods = useFormContext<OrderFormSchema>();
	const currentQuantity = useWatch({
		control: methods.control,
		name: `articles.${itemIndex}.quantity`,
	});
	const quantity = guardNumber(currentQuantity);
	const hasQuantity = quantity > 0;
	const availableQuantity = guardNumber(item.availableQuantity);
	const isOverMaxQuantity = quantity > availableQuantity;

	/** Render */
	return (
		<div className="h-stack justify-end pr-4">
			{isOverMaxQuantity ? (
				<div className="h-stack">
					<p>
						{t("stock.quantity_is_over_orderable_quantity", {
							available: formatNumber(Math.max(0, availableQuantity), "integer", 0),
						})}
					</p>
					<AlertIcon variant="danger" />
				</div>
			) : (
				!hasQuantity && <AlertIcon variant="warning" />
			)}
		</div>
	);
}
